import { render } from "./AboutCompass.vue?vue&type=template&id=71f6677e"
import script from "./AboutCompass.vue?vue&type=script&lang=js"
export * from "./AboutCompass.vue?vue&type=script&lang=js"

import "./AboutCompass.vue?vue&type=style&index=0&id=71f6677e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__